export const LABELS = {
    boxId: 'מיקום (ארגז)',
    documentLongId: 'מספר מזהה',
    author: 'עורך',
    totalPages: 'מס’ עמודים / קבצים במסמך',
    keywords: 'מילות מפתח',
    type_id: 'סוג המסמך',
    folderLongId: 'מספר קלסר',
    language: 'שפה',
    mediaType: 'סוג מדיה',
    type: 'סוג מסמך',
    lastUpdated: 'תאריך הפקדה לארכיון',
    documentNumber: 'מס. מסמך בקלסר',
    categoryCaption: 'קטגוריה',
    keywordsCaption: 'מילות מפתח'
}
